export enum ActivityAction {
  CREATE = 'create',
  UPDATE = 'update',
  QC_UPDATE = 'qc_update',
  SUBMIT = 'submit',
  RESUBMIT = 'resubmit',
  REVERT = 'revert',
  FAX_PATHOLOGY_FILES = 'fax_pathology_files',
  CANCEL = 'cancel',
  FAXED_BILLING_FILES = 'faxed_billing_files',
  MARK_QC_APPROVED = 'mark_qc_approved',
  MARK_QC_REJECTED = 'mark_qc_rejected',
  MARK_LAB_PROCESSING = 'mark_lab_processing',
  MARK_REPORT_PENDING = 'mark_report_pending',
  MARK_AI_ERROR = 'mark_ai_error',
  MARK_LAB_ERROR = 'mark_lab_error',
  MARK_REPORT_READY = 'mark_report_ready',
  MARK_REPORT_FAXED = 'mark_report_faxed',
  MARK_REPORT_REJECTED = 'mark_report_rejected',
  MARK_TRF_FAXED = 'mark_trf_faxed',
  MARK_AI_PROCESSING = 'mark_ai_processing',
  FAX_TEST_REPORT_ORDERING_PROVIDER = 'fax_test_report_ordering_provider',
  FAX_TEST_REPORT_PATHOLOGY_LAB = 'fax_test_report_pathology_lab',
  UPLOAD_FILE = 'upload_file',
  DELETE_FILE = 'delete_file',
  REVISE_REPORT = 'revise_report',
  SHARE_TEST_REPORT = 'share_test_report',
  QC_APPROVE_SLIDE_IMAGE = 'qc_approve_slide_image',
  QC_REJECT_SLIDE_IMAGE = 'qc_reject_slide_image',
}

export enum ActivityResourceType {
  ORDERING_PROVIDER = 'ordering_provider',
  ORDER = 'order',
}
